module.exports = __webpack_public_path__ + "img/engelstrompete_1.147f66aa.jpg";